/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} VisibilityInputs */

const en_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility`)
};

const es_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilidad`)
};

const fr_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilité`)
};

const de_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbarkeit`)
};

const ja_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開設定`)
};

const zh_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可见性`)
};

const ar_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الظهور`)
};

const id_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilitas`)
};

const it_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilità`)
};

const ru_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видимость`)
};

const pt_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilidade`)
};

const ko_visibility = /** @type {(inputs: VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공개 상태`)
};

/**
* | output |
* | --- |
* | "Visibility" |
*
* @param {VisibilityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const visibility = /** @type {((inputs?: VisibilityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<VisibilityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_visibility(inputs)
	if (locale === "es") return es_visibility(inputs)
	if (locale === "fr") return fr_visibility(inputs)
	if (locale === "de") return de_visibility(inputs)
	if (locale === "ja") return ja_visibility(inputs)
	if (locale === "zh") return zh_visibility(inputs)
	if (locale === "ar") return ar_visibility(inputs)
	if (locale === "id") return id_visibility(inputs)
	if (locale === "it") return it_visibility(inputs)
	if (locale === "ru") return ru_visibility(inputs)
	if (locale === "pt") return pt_visibility(inputs)
	return ko_visibility(inputs)
});